import { Container, Heading, Stack } from "@chakra-ui/react";
import { Summary } from "../components/Summary";
import { TransactionForm } from "../components/TransactionForm";
import { TransactionList } from "../components/TransactionList";

export default function AddAmountMask() {
  return (
    <Container maxW="lg" py={10} pb={{ base: 24, md: 10 }}>
      <Stack spaceY={6}>
        <Heading textAlign="center">Betrag hinzufügen</Heading>
        <Summary />
        <TransactionForm />
        <TransactionList />
      </Stack>
    </Container>
  );
}
